import React, { useEffect, useRef, useMemo } from 'react'
import AdWrapper from './AdWrapper'
import DummyAd from './DummyAd'
import { BaseAdProps } from './types'

type GoogleAdProps = BaseAdProps & {
  client: string
  slot: string
  adFormat?: 'auto' | 'fluid'
  adLayout?: string
  adLayoutKey?: string
  adChannel?: number | string // AdSense channel number may be a number, or a string like 123+456
}

const GoogleAd: React.FC<GoogleAdProps> = ({
  client,
  slot,
  adFormat = 'auto',
  adLayout,
  adLayoutKey,
  adChannel,
  showAds,
  environment,
}) => {
  const adRef = useRef(null)
  const showPlaceholder = useMemo(() => environment === 'development', [environment])
  useEffect(() => {
    if (adRef.current) {
      if (showAds && !showPlaceholder) {
        try {
          ;(window.adsbygoogle = window.adsbygoogle || []).push({})
        } catch (e) {
          console.warn('Adsbygoogle push error:', e)
        }
      }
    }
  }, [showAds, environment])

  const getAdContent = () => {
    return !showAds || showPlaceholder ? (
      <DummyAd />
    ) : (
      <ins
        ref={adRef}
        className="adsbygoogle ad"
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-channel={adChannel}
        data-ad-format={adFormat}
        data-ad-layout={adLayout}
        data-ad-layout-key={adLayoutKey}
      />
    )
  }

  return (
    <AdWrapper showAds={showAds} environment={environment}>
      {getAdContent()}
    </AdWrapper>
  )
}

GoogleAd.displayName = 'GoogleAd'

export default GoogleAd
